import React from 'react';

type Props = { fallback?: React.ReactNode; children: React.ReactNode };

type State = { hasError: boolean };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: any, info: any) {
    try {
      console.error('UI ErrorBoundary', error);
      if (error?.stack) console.error('UI ErrorBoundary error.stack:', error.stack);
      if (info?.componentStack) console.error('UI ErrorBoundary componentStack:', info.componentStack);
      console.error('UI ErrorBoundary info:', info);
    } catch {}
  }

  render() {
    if (this.state.hasError) return this.props.fallback || null;
    return this.props.children;
  }
}
